interface AlertIconWithGradientProps {
  icon: React.ReactNode;
  gradientColor: string;
  type?: 'success' | 'info' | 'default';
}

const AlertIconWithGradient: React.FC<AlertIconWithGradientProps> = (props) => {

  const { icon, gradientColor, type = 'default' } = props;

  return (
    <div style={{ position: 'relative', width: 32, height: 32, marginTop: 2, flexShrink: 0, zIndex: 1 }}>
      <div
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          width: type === 'success' || type === 'info' ? 56 : 900,
          height: type === 'success' || type === 'info' ? 56 : 900,
          borderRadius: '50%',
          background:
            type === 'success'
              ? 'radial-gradient(50% 50% at 50% 50%, rgba(0,237,81,0.16) 0%, rgba(0,237,123,0) 100%)'
              : type === 'info'
                ? 'radial-gradient(50% 50% at 50% 50%, rgba(255,212,38,0.16) 0%, rgba(255,212,38,0) 100%)'
                : `radial-gradient(circle, rgba(${gradientColor},0.06) 0%, rgba(${gradientColor},0.03) 40%, rgba(${gradientColor},0.01) 80%, rgba(${gradientColor},0) 100%)`,
          zIndex: 0,
          pointerEvents: 'none',
          filter: 'blur(8px)',
          transform: 'translate(-50%, -50%)',
        }}
      />
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: 32,
          height: 32,
          borderRadius: '50%',
          background: '#ffffff1a',
          zIndex: 1,
          pointerEvents: 'none',
        }}
      />
      <div
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          width: 24,
          height: 24,
          transform: 'translate(-50%, -50%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2,
        }}
      >
        {icon}
      </div>
    </div>
  );
};

export default AlertIconWithGradient;